import moment from 'moment';

export const getISODate = (date: string | null | undefined): string | null => {
  if (date === null || date === undefined) return null;
  if (typeof date === 'string' && date.trim() === "") {
    console.error("Invalid date: empty string");
    return null;
  }

  try {
    const momentDate = moment(date);
    if (!momentDate.isValid()) {
      console.error(`Invalid date format: ${date}`);
      return null;
    }
    
    return momentDate.toISOString();
  } catch (error) {
    console.error(`Invalid date format: ${date}`);
    return null;
  }
};